<template>
  <div class="informations">
    <div class="information-list"
      v-for="(item, index) in articleList"
      :key="index" @click="openNews(item)">
      <img class="item-img" :src="item.cover.url | handleImageUrl('248', '150')" v-if="item.cover">
      <div class="item-content" :class="item.cover ? 'hasCoverCoent' : ''">
        <div class="item-title" :class="item.cover ? 'hasCoverTitle' : ''">
          {{ item.title ? item.title : item._source.title }}
        </div>
        <div class="item-source">
          <span class="source">{{ item.article_category_name }}</span>
          <span class="update-time">{{ item.updated_at ? item.updated_at : item._source.created_at | formatTime('mm/dd') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    articleList: {
      type: Array,
      default: () => [],
    },
    isShowHead: {
      type: Boolean,
      default: () => false,
    },
    categoryTitle: {
      type: String,
      default: () => '',
    }
  },

  methods: {
    openNews(item) {
      let href = `/news/view.html?id=${item.id ? item.id : item._source.id}&categoryTitle=${this.categoryTitle}`;
      if (this.isShowHead) {
        href += '&isShowHead=true';
      }
      window.location.href = href;
    }
  }
}
</script>
<style scoped>
  /* finish #2041 */
  .informations {
    overflow-y: scroll;
    touch-action: pan-y;
    -webkit-overflow-scrolling: touch;
  }

  .information-list {
    display: flex;
    margin-top: 20px;
    padding: 0 25px 25px;
    box-sizing: border-box;
  }

  .item-img {
    margin-right: 25px;
    width: 248px;
    height: 150px;
    border-radius: 5px;
  }

  .hasCoverCoent {
    width: 416px;
  }

  .item-title {
    margin-bottom: 15px;
    line-height: 42px;
    font-size: 30px;
    color: #333;
    font-family: Source Han Sans CN;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .hasCoverTitle {
    margin-bottom: 66px;
  }

  .item-source {
    height: 24px;
    line-height: 24px;
  }

  .source {
    margin-right: 20px;
    font-size: 26px;
    color: #999;
  }

  .update-time {
    font-size: 24px;
    color: #e72020;
  }
</style>
